// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Borrow = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.727 8.438a1.969 1.969 0 1 0 0-3.937 1.969 1.969 0 0 0 0 3.937"
    />
    <path
      stroke="currentColor"
      d="M3.758 15.188H.945v-3.937h2.813M8.258 11.813h2.13l3.965-.889c1.43-.321 2.165.155 2.702 1.546l-3.735 1.593-4.5 1.125H3.758v-3.937l1.758-1.758a1.69 1.69 0 0 1 1.195-.492c1.318 0 4.922 1.406 4.922 1.406a1.406 1.406 0 0 1-1.406 1.406z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.758 6.56a1.969 1.969 0 1 1 1.125-1.869"
    />
  </svg>
);
const ForwardRef = forwardRef(Borrow);
export default ForwardRef;
